import react from 'react'

export const ApplicationMenu = ({ maxStep, onNav, currentStep, statuses }) => {
  const pos = statuses.findIndex(s => s === maxStep)

  const labelForStep = (step: string) => {
    switch (step) {
      case 'Loan Request':
        return 'Introduction'
      case 'Review Contract':
        return 'Submit Loan Application'
      default:
        return step
    }
  }

  return <div className="caf-menu">
    {statuses.filter(s => s !== 'Submit Application').map((step, i) => <div
      key={i}
      className={['step', i <= pos ? 'active' : '', currentStep === step ? 'current' : ''].join(' ')}
      onClick={() => {
        if (i <= pos) {
          onNav(statuses[i])
        }
      }}
      style={i <= pos ? { cursor: 'pointer' } : {}}
    >{labelForStep(step)}</div>)}
  </div>
}

export default ApplicationMenu